import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getActiveUserList, rejectPendingUser } from "actions/pending";
import PropTypes from "prop-types";
import DataTable from "react-data-table-component";
import "reactjs-popup/dist/index.css";
import TopNav from "views/Components/SuperAdmin/Navbars/TopNav/index";
import Sidenav from "views/Components/SuperAdmin/Navbars/Sidebar/index";
import deleteCross from "assets/superAdmin/PendingReques/deleteCross.svg";
import eye from "assets/land/eye.svg";

const customStyles = {
  headCells: {
    style: {
      fontWeight: "600",
      fontSize: "1.5rem",
      textTransform: "capitalize",
      paddingLeft: ".5rem", // override the cell padding for head cells
      paddingRight: ".5rem",
    },
  },
  rows: {
    style: {
      minHeight: "3rem", // override the row height
    },
  },
  cells: {
    style: {
      paddingLeft: ".5rem", // override the cell padding for data cells
      paddingRight: ".5rem",
    },
  },
};

const Index = ({
  rejectPendingUser,
  getActiveUserList,
  pendingList,
  history,
}) => {
  const queryParams = new URLSearchParams(window.location.search);
  const name = queryParams.get("name");

  const [pending, setPending] = useState(true);

  useEffect(() => {
    getActiveUserList().then((res) => {
      if (res === undefined) {
        setPending(false);
      } else {
        setPending(false);
      }
    });
  }, [getActiveUserList]);

  useEffect(() => {}, []);

  //cancel form submit
  //////////////////SEARCHING/FILTER///////////////////
  const [searchs, setNewSearch] = useState("");
  const handleSearchChange = (e) => {
    setNewSearch(e.target.value);
  };
  const filtered = !searchs
    ? pendingList
    : pendingList.filter(
        (el) =>
          el.name.toLowerCase().includes(searchs.toLowerCase()) ||
          el.email.toLowerCase().includes(searchs.toLowerCase()) ||
          el.phone.toLowerCase().includes(searchs.toLowerCase()) ||
          (el.organization_name || "")
            .toLowerCase()
            .includes(searchs.toLowerCase()) ||
          el.created_on.toLowerCase().includes(searchs.toLowerCase()),
      );
  //////////////////SEARCHING/FILTER///////////////////
  const columns = [
    {
      name: "Sr",
      selector: (row, index) => index + 1,
      sortable: true,
      maxWidth: "4rem",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      grow: 2,
    },
    {
      name: "Organization",
      selector: (row) => row.organization_name || "Not configured",
      sortable: true,
      grow: 2,
    },
    {
      name: "Accountant",
      selector: (row) => row.accountant_count,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => row.action,
      center: true,
      cell: (row) => {
        return (
          <>
            <Link
              to={`/app/admin/active-user-profile?name=${row.name}&id=${row.id}`}
            >
              <img className="cursor" src={eye} alt="edit status" />
            </Link>

            <div className="tooltip">
              <span className="tooltiptext">Inactive</span>
              <button
                type="button"
                className="ml-s-sm cursor"
                aria-label={`Set ${row.name} as inactive`}
                onClick={() => {
                  delete_user(row);
                }}
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                }}
              >
                <img
                  className="cursor"
                  src={deleteCross}
                  alt="deleteCross status"
                />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const delete_user = (row) => {
    const user_id = row.id;
    const status_reject = 3;
    rejectPendingUser(user_id, status_reject, history);
  };
  return (
    <>
      <TopNav />
      <Sidenav />

      <div className="listings">
        <div className="listing__breadcrum">
          <span className="font-14 ">
            <Link className="op-2" to="/app/admin/dashboard">
              Home/ Dashboard/{" "}
            </Link>
            <span className="c__blue">{name}Active Users</span>
          </span>
        </div>
        <div className="listing">
          <div className="listing__header mb-md">
            <h3 className="heading-3 cap">{name}Active Users</h3>
            <div className="listing__right">
              <Input
                className="form__search"
                type="search"
                name="search"
                placeholder="Search..."
                value={searchs}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filtered}
            // data={activeUser}
            highlightOnHover={true}
            pagination={true}
            persistTableHead={true}
            customStyles={customStyles}
            progressPending={pending}
          />
        </div>
      </div>
    </>
  );
};

Index.proTypes = {
  getActiveUserList: PropTypes.object.isRequired,
  pendingList: PropTypes.array.isRequired,
  rejectPendingUser: PropTypes.object.isRequired,
  errorList: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  pendingList: state.pending.pendingList,
  errorList: state.errors,
  loading: state.auth.loading,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getActiveUserList,
  rejectPendingUser,
})(Index);
